// import external dependencies

import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js";
import "./cmgform_html_5";
import "./doubleTap";

jQuery(document).ready(() => {
  $(".navbar-collapse").doubleTapToGo();
  $(".navbar-toggler").click(function() {
    $(this).toggleClass("christ");
  });
  if ($(window).width() > 991) {
    $(".dropdown-toggle").click(function() {
      $(".dropdown-menu").removeClass("show");
    });
  }
  if ($(window).width() < 992) {
    $(".dropdown-toggle").attr("data-toggle", "dropdown");
  } else {
    $(".dropdown-menu").removeClass("show");
    $(".dropdown-toggle").removeAttr("data-toggle");
  }
  $(window).resize(function() {
    if ($(window).width() < 992) {
      $(".dropdown-toggle").attr("data-toggle", "dropdown");
    } else {
      $(".dropdown-menu").removeClass("show");
      $(".dropdown-toggle").removeAttr("data-toggle");
    }
  });
  window.addEventListener("orientationchange", function() {
    $(".navbar-collapse").removeClass("show");
    $(".navbar-toggler").removeClass("christ");
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js